import { useEffect, useState } from "react";
import { API } from "../data/siteData";
import useContentPageForm from "./useContentPageForm";

export { defaultPageContent, editablePages } from "../data/editablePageContent";

export default function usePageContentEditor(pages, onRefresh) {
  const [state, setState] = useState("idle");
  const [message, setMessage] = useState("");
  const editorForm = useContentPageForm(pages);
  const {
    addSection,
    form,
    hasOverride,
    pageKey,
    removeSection,
    resetForm,
    setPageKey,
    update,
    updateSection,
  } = editorForm;

  useEffect(() => {
    setMessage("");
    setState("idle");
  }, [pageKey, pages]);

  const save = async (event) => {
    event.preventDefault();
    setState("loading");
    setMessage("");
    const response = await fetch(`${API}/admin/content-pages/${pageKey}`, {
      method: "PUT",
      credentials: "include",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(form),
    });
    if (!response.ok) {
      setState("error");
      setMessage("This page update could not be saved. Please check the fields and try again.");
      return;
    }
    setState("success");
    setMessage("Public page override saved.");
    await onRefresh();
  };

  const reset = async () => {
    if (!hasOverride) return;
    if (!window.confirm("Restore the original public-page content for this page?")) return;
    const response = await fetch(`${API}/admin/content-pages/${pageKey}`, {
      method: "DELETE",
      credentials: "include",
    });
    if (!response.ok) {
      setState("error");
      setMessage("The page could not be reset.");
      return;
    }
    resetForm();
    setState("success");
    setMessage("Original public-page content restored.");
    await onRefresh();
  };

  return {
    addSection,
    form,
    message,
    pageKey,
    removeSection,
    reset,
    save,
    setPageKey,
    state,
    update,
    updateSection,
  };
}